import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { finalize, take } from 'rxjs/operators';
import { PayService } from '../service/pay.service';
import { DeviceChallengeResponse, JwtResponse, LoginPayload } from '../service/auth.service';
import { UserSessionService } from '../user-session.service';
import { PrelevementSoftPayRequest } from '../models/prelevementSoftPayRequest';
import { ApiResponse } from '../models/api-response';

type LoginForm = {
    username: FormControl<string>;
    password: FormControl<string>;
};


@Component({
    selector: 'app-onlinegetway',
    templateUrl: './onlinegetway.component.html',
    styleUrls: ['./onlinegetway.component.css'],
    standalone: false
})
export class OnlinegetwayComponent implements OnInit {
    userLogin!: FormGroup<LoginForm>;
    loader = false;
    hideloginform: boolean = false;
    user: any;
    firstname: any;
    lastname: any;
    compte: string;
    solde: any;
    locationurl: string;
    baccountNumber: string;
    montan: number;
    soldeInsuifisant: boolean = false;
    sigle: any;
    boutique: string;
    articlenom: string;
    prix: number;
    quantite: number;
    prixTotal: number;
    retourOk: string;
    retourNotOk: string;
    clickEventListener: any; // Store the event listener reference
    private hasPaymentParams = false;
    action: 'pay' | 'confirm' | 'refund' | 'return' | 'return-confirm' | 'subscription' = 'pay';
    purchaseTxId?: number;
    merchantAccountId?: number;
    merchantAccountCode?: string;
    currency?: string;
    lastTxId?: number;









    /*
      typ=1------> le client paye son article
      typ=2------> le client paye les frais de retour
      typ=3------> le vendeur paye un abonement annuel
      typ=4-----> le vendeur paye une facturation mensuel- doit etre verifié
      typ=5-----> le vendeur effectue un remborsement au client
      typ=6----->le vendeur paye les mensualite du livreur
      typ=7----->le vendeur paye les commision mensuel
    */
    typ: number;
    succesMessage: boolean;
    errorMessage: boolean;
    errorcompte: boolean;
    CNINotConfirm: boolean;
    phoneNotConfirm: boolean;
    problemAcure: boolean = false;
    periodicity: 'MONTHLY' | 'YEARLY' = 'YEARLY';
    autoRenew: boolean = false;
    validatingDevice = false;
    deviceChallenge: DeviceChallengeResponse | null = null;
    deviceChallengeError = '';
    pendingUsername = '';
    readonly deviceOtp = new FormControl<string>('', {
        nonNullable: true,
        validators: [Validators.required, Validators.pattern('^[0-9]{6}$')]
    });
    constructor(private userService: PayService, private userSessionService: UserSessionService) {
        const search = location.href.split('?')[1] || '';
        const params = new URLSearchParams(search);
        const payloadParam = params.get('payload');
        console.log(payloadParam);

        if (payloadParam) {
            try {
                const decoded = JSON.parse(atob(decodeURIComponent(payloadParam)));
                this.boutique = decoded.boutique || '';
                this.baccountNumber = decoded.baccountNumber || '';
                this.merchantAccountId = decoded.merchantAccountId;
                this.merchantAccountCode = decoded.merchantAccountCode;
                this.articlenom = decoded.identification || '';
                this.quantite = Number(decoded.quantite || 0);
                this.prixTotal = Number(decoded.totalAPayer || 0);
                this.retourOk = decoded.retourOk || '';
                this.retourNotOk = decoded.retourNotOk || '';
                this.typ = Number(decoded.typ || 1);
                this.action = (decoded.action || 'pay') as any;
                this.periodicity = (decoded.periodicity || 'YEARLY').toUpperCase() === 'MONTHLY' ? 'MONTHLY' : 'YEARLY';
                this.autoRenew = !!decoded.autoRenew;
                this.purchaseTxId = decoded.purchaseTxId ? Number(decoded.purchaseTxId) : undefined;
                this.currency = decoded.currency;
                this.hasPaymentParams = true;
            } catch (e) {
                console.warn('OnlinegetwayComponent: payload illisible', e);
            }
        } else {
            // rétro-compatibilité ancien format "name=a,b,c,..."
            const raw = search.split('name=')[1];
            if (raw) {
                const decodedRaw = decodeURIComponent(raw);
                const array = decodedRaw.split(',');
                if (array.length >= 5) {
                    this.boutique = array[0] || '';
                    this.baccountNumber = array[1] || '';
                    this.articlenom = array[2] || '';
                    this.quantite = Number(array[3] || 0);
                    this.prixTotal = Number(array[4] || 0);
                    this.retourOk = array[5] || '';
                    this.retourNotOk = array[6] || '';
                    this.typ = Number(array[7] || 1);
                    this.action = 'pay';
                    this.hasPaymentParams = true;
                }
            }
        }

        if (!this.hasPaymentParams) {
            console.warn('OnlinegetwayComponent: aucun paramètre de paiement détecté dans l’URL.');
            return;
        }
    }

    ngOnInit() {
        this.ngOnlogin();
    }

    ngOnlogin() {
        this.userLogin = new FormGroup<LoginForm>({
            username: new FormControl<string>('', {
                nonNullable: true,
                validators: [
                    Validators.required,
                    Validators.pattern('[^ @]*@[^ @]*|((^(65)[0-9]{1}[0-9]{6}|^(69|66|67|64)[0-9]{7}))$')
                ]
            }),
            password: new FormControl<string>('', {
                nonNullable: true,
                validators: [Validators.required, Validators.minLength(6), Validators.maxLength(64)]
            })
        });

    }
    onlogin(formData?: LoginPayload) {
        if (!this.hasPaymentParams) {
            this.problemAcure = true;
            return;
        }

        if (this.userLogin.invalid) {
            this.userLogin.markAllAsTouched();
            return;
        }

        const payload: LoginPayload = formData ?? this.userLogin.getRawValue();
        const trimmed = (payload.username || '').trim();
        payload.username = trimmed.includes('@') ? trimmed.toLowerCase() : trimmed;
        this.pendingUsername = payload.username;

        this.loader = true;
        this.problemAcure = false;

        this.userService.login(payload).pipe(take(1)).subscribe({
            next: resp => {
                if (this.isDeviceChallengeResponse(resp)) {
                    this.deviceChallenge = resp;
                    this.deviceChallengeError = '';
                    this.deviceOtp.reset('');
                    this.loader = false;
                    return;
                }

                this.completeAuthenticatedSession(resp as JwtResponse, payload.username);
            },
            error: () => {
                this.problemAcure = true;
                setTimeout(() => {
                    this.problemAcure = false;
                }, 4000);
                this.loader = false;
            }
        });

    }

    submitDeviceValidation(): void {
        if (!this.deviceChallenge || !this.pendingUsername) {
            return;
        }
        if (this.deviceOtp.invalid) {
            this.deviceOtp.markAsTouched();
            return;
        }

        this.validatingDevice = true;
        this.deviceChallengeError = '';
        this.userService.verifyTrustedDevice({
            username: this.pendingUsername,
            challengeToken: this.deviceChallenge.challengeToken,
            otp: this.deviceOtp.value
        }).pipe(take(1)).subscribe({
            next: res => {
                this.completeAuthenticatedSession(res, this.pendingUsername);
                this.closeDeviceChallenge();
                this.validatingDevice = false;
            },
            error: err => {
                this.validatingDevice = false;
                this.deviceChallengeError = this.resolveDeviceChallengeError(err);
            }
        });
    }

    closeDeviceChallenge(): void {
        this.deviceChallenge = null;
        this.deviceOtp.reset('');
        this.deviceChallengeError = '';
    }

    get challengeExpiryLabel(): string {
        const isoDate = this.deviceChallenge?.expiresAt;
        if (!isoDate) {
            return '';
        }
        const date = new Date(isoDate);
        if (Number.isNaN(date.getTime())) {
            return '';
        }
        return date.toLocaleString('fr-FR');
    }

    private completeAuthenticatedSession(response: JwtResponse, fallbackUsername: string): void {
        this.userService.saveConnectedUser(response);
        if (response.refreshToken) {
            localStorage.setItem('refreshToken', response.refreshToken);
        }
        const username = this.userSessionService.getUser()?.username || fallbackUsername;
        this.userService.saveUsername(username);
        this.loadUserProfile(username);
    }

    private isDeviceChallengeResponse(payload: any): payload is DeviceChallengeResponse {
        return !!payload && payload.deviceValidationRequired === true && !!payload.challengeToken;
    }

    private resolveDeviceChallengeError(err: HttpErrorResponse): string {
        if (typeof err?.error === 'string' && err.error.trim()) {
            return err.error;
        }
        switch (err?.status) {
            case 400:
                return 'Code OTP invalide.';
            case 404:
                return 'Challenge introuvable. Reconnectez-vous.';
            case 409:
                return 'Challenge déjà utilisé. Reconnectez-vous.';
            case 410:
                return 'Challenge expiré. Reconnectez-vous.';
            case 423:
                return 'Trop de tentatives. Reconnectez-vous.';
            default:
                return 'Validation impossible pour le moment.';
        }
    }

    private loadUserProfile(username: string) {
        this.userService.getUtilisateursInformations(username).pipe(
            take(1),
            finalize(() => this.loader = false)
        ).subscribe({
            next: data => {
                this.hideloginform = true;
                this.user = data;
                this.firstname = this.user['firstName'];
                this.lastname = this.user['lastName'];
                this.compte = this.userSessionService.getUser().primaryAccountNumber;
                this.sigle = this.userSessionService.getUser().primaryAccountSigle;

                if (this.typ === 6 || this.typ === 5 || this.typ === 7 || this.typ === 4) {
                    // compteementeur
                    this.compte = this.articlenom;
                    this.initsoldeCompteaffaire();
                }
                else if (this.action === 'pay' || this.action === 'subscription') {
                    this.solde = this.userSessionService.getDisplayPrimaryAccountBalance();

                    if ((this.typ === 1 || this.typ === 2 || this.typ === 3) && Number(this.solde) < this.prixTotal) {
                        this.soldeInsuifisant = true;

                    }
                }
                // en mode confirmation, on ne vérifie pas le solde
            },
            error: () => {
                this.problemAcure = true;
                setTimeout(() => this.problemAcure = false, 4000);
            }
        });
    }

    initsoldeCompteaffaire() {
        this.userService.getcompteBussinessSolde(this.compte).subscribe(data => {
            console.log(data);
            this.solde = data['accountBalance'];
            if (Number(this.solde) < this.prixTotal) {
                this.soldeInsuifisant = true;

            }
        });
    }

    takemeBack(status: any) {
        this.loader = true;
        // Detect a click event and send a message to the parent window
        document.addEventListener('click', () => {
            // Close the child window
            window.close();

            // Inform parent without navigation
            if (window.opener) {
                window.opener.postMessage({ event: 'spay-closed', status, txId: this.lastTxId }, '*');
            }
        });

    }



    confirmerPaiement() {
        this.loader = true;
        const isSubscription = this.action === 'subscription' || this.typ === 3;

        const obs$ = isSubscription
            ? this.userService.paySubscription({
                primaryAccountNumber: this.compte,
                businessAccountNumber: this.baccountNumber,
                amount: this.prixTotal,
                currency: this.currency || this.sigle,
                referenceId: Date.now(),
                periodicity: this.periodicity,
                autoRenew: this.autoRenew
            })
            : this.userService.prelevementSoftPay(this.buildPrelevementPayload());

        obs$.pipe(take(1)).subscribe({
            next: (res: ApiResponse<any>) => {
                const code = res?.code ?? -99;
                const txId = res?.data?.transactionId;
                this.lastTxId = txId;
                let statusForReturn = 1;
                if (code === 0) statusForReturn = 0;
                else if (code === -2) statusForReturn = 2; // solde insuffisant
                else if (code === -7 || code === -3) statusForReturn = 4; // compte primaire introuvable
                if (code === 0) {
                    this.succesMessage = true;
                    setTimeout(() => {
                        this.succesMessage = false;
                        this.loader = false;
                        if (window.opener) {
                            window.opener.postMessage({ event: 'spay-closed', status: 0, txId }, '*');
                        }
                        window.close();
                    }, 500);
                    return;
                }
                // mapping codes -> flags
                switch (code) {
                    case -1:
                        this.errorMessage = true; // business not found
                        break;
                    case -2:
                        this.soldeInsuifisant = true;
                        break;
                    case -3:
                    case -7:
                        this.errorcompte = true;
                        break;
                    case -10:
                        this.phoneNotConfirm = true;
                        break;
                    case -11:
                        this.CNINotConfirm = true;
                        break;
                    default:
                        this.problemAcure = true;
                }
                setTimeout(() => {
                    this.errorMessage = this.soldeInsuifisant = this.errorcompte = this.phoneNotConfirm = this.CNINotConfirm = this.problemAcure = false;
                    this.loader = false;
                    if (window.opener) {
                        window.opener.postMessage({ event: 'spay-closed', status: statusForReturn, txId }, '*');
                    }
                    window.close();
                }, 1500);
            },
            error: () => {
                this.problemAcure = true;
                setTimeout(() => {
                    this.problemAcure = false;
                    this.loader = false;
                    if (window.opener) {
                        window.opener.postMessage({ event: 'spay-closed', status: 1, txId: this.lastTxId }, '*');
                    }
                    window.close();
                }, 1500);
            }
        });
    }

    private buildReturnUrl(status: number, includeTxId: boolean) {
        // Gestion spécifique hash routing : on place les params dans le fragment
        if (this.retourOk && this.retourOk.includes('#')) {
            const [base, hashFrag] = this.retourOk.split('#', 2);
            const [path, existingQuery] = hashFrag.split('?', 2);
            const qp = new URLSearchParams(existingQuery || '');
            qp.set('status', status.toString());
            if (includeTxId && this.lastTxId) {
                qp.set('txId', this.lastTxId.toString());
            } else {
                qp.delete('txId');
            }
            return `${base}#${path}?${qp.toString()}`;
        }

        // Fallback URL classique
        try {
            const url = new URL(this.retourOk);
            url.searchParams.set('status', status.toString());
            if (includeTxId && this.lastTxId) {
                url.searchParams.set('txId', this.lastTxId.toString());
            } else {
                url.searchParams.delete('txId');
            }
            return url.toString();
        } catch (e) {
            const sep = this.retourOk?.includes('?') ? '&' : '?';
            const tx = includeTxId && this.lastTxId ? `&txId=${this.lastTxId}` : '';
            return `${this.retourOk}${sep}status=${status}${tx}`;
        }
    }

    confirmReception() {
        if (!this.purchaseTxId) {
            this.problemAcure = true;
            return;
        }
        this.loader = true;
        this.userService.confirmDelivery(this.purchaseTxId, {
            businessAccountId: this.merchantAccountId,
            businessAccountCode: this.merchantAccountCode,
            currency: this.currency,
            releaseNow: true
        }).pipe(take(1)).subscribe({
            next: () => {
                this.succesMessage = true;
                setTimeout(() => {
                    this.succesMessage = false;
                    this.loader = false;
                    if (window.opener) {
                        window.opener.postMessage({ event: 'spay-closed', status: 0, txId: this.lastTxId }, '*');
                    }
                    window.close();
                }, 500);
            },
            error: () => {
                this.problemAcure = true;
                setTimeout(() => {
                    this.problemAcure = false;
                    this.loader = false;
                    if (window.opener) {
                        window.opener.postMessage({ event: 'spay-closed', status: 1, txId: this.lastTxId }, '*');
                    }
                }, 1500);
            }
        });
    }

    requestReturn() {
        if (!this.purchaseTxId) {
            this.problemAcure = true;
            return;
        }
        this.loader = true;
        this.userService.requestReturn(this.purchaseTxId, {
            businessAccountId: this.merchantAccountId,
            businessAccountCode: this.merchantAccountCode,
            currency: this.currency,
            amount: this.prixTotal,
            reason: 'Client demande un retour'
        }).pipe(take(1)).subscribe({
            next: () => {
                this.succesMessage = true;
                setTimeout(() => {
                    this.succesMessage = false;
                    this.loader = false;
                    if (window.opener) {
                        window.opener.location.href = this.buildReturnUrl(0, false);
                        window.opener.postMessage({ event: 'spay-closed', status: 0 }, '*');
                    }
                    window.close();
                }, 500);
            },
            error: () => {
                this.problemAcure = true;
                setTimeout(() => {
                    this.problemAcure = false;
                    this.loader = false;
                    if (window.opener) {
                        window.opener.location.href = this.buildReturnUrl(1, false);
                        window.opener.postMessage({ event: 'spay-closed', status: 1 }, '*');
                    }
                    window.close();
                }, 1500);
            }
        });
    }

    confirmReturn() {
        if (!this.purchaseTxId) {
            this.problemAcure = true;
            return;
        }
        this.loader = true;
        this.userService.confirmReturn(this.purchaseTxId, {
            businessAccountId: this.merchantAccountId,
            businessAccountCode: this.merchantAccountCode,
            currency: this.currency
        }).pipe(take(1)).subscribe({
            next: () => {
                this.succesMessage = true;
                setTimeout(() => {
                    this.succesMessage = false;
                    this.loader = false;
                    if (window.opener) {
                        window.opener.location.href = this.buildReturnUrl(0, false);
                        window.opener.postMessage({ event: 'spay-closed', status: 0 }, '*');
                    }
                    window.close();
                }, 500);
            },
            error: () => {
                this.problemAcure = true;
                setTimeout(() => {
                    this.problemAcure = false;
                    this.loader = false;
                    if (window.opener) {
                        window.opener.location.href = this.buildReturnUrl(1, false);
                        window.opener.postMessage({ event: 'spay-closed', status: 1 }, '*');
                    }
                    window.close();
                }, 1500);
            }
        });
    }



    private buildPrelevementPayload(): PrelevementSoftPayRequest {
        const username = localStorage.getItem('usernameThatUserIsNowConnect2345789');
        return {
            username: username ?? '',
            compte: this.compte,
            baccountNumber: this.baccountNumber,
            valeur: this.prixTotal,
            boutique: this.boutique,
            articlenom: this.articlenom,
            quantite: this.quantite,
            typ: this.typ
        };
    }


    ngOnDestroy(): void {
        // plus d'écouteur ajouté dynamiquement
    }
}
